import get from 'lodash/get';

export const getPageName = () => (
  get(window, 'initialState.app.page.name') || ''
);

export const getDisplayPageName = () => (
  get(window, 'initialState.app.page.displayName') || ''
);
